import React from 'react';

import { CustomSVGProps } from './CustomSVGProps.types';

export function IconCinemaScreen16(props: CustomSVGProps): React.JSX.Element {
    return (
        <svg
            {...props}
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden={!props.onClick}
            aria-label="cinema screen">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M0.344798 2.24455C0.563798 2.05462 0.854443 1.96906 1.14142 2.01006L1.91888 2.12112C5.95249 2.69735 10.0475 2.69735 14.0811 2.12112L14.8586 2.01006C15.1456 1.96906 15.4362 2.05462 15.6552 2.24455C15.8742 2.43449 16 2.71012 16 3.00001V12C16 12.2899 15.8742 12.5655 15.6552 12.7555C15.4362 12.9454 15.1456 13.031 14.8586 12.99L14.0811 12.8789C10.0475 12.3027 5.95249 12.3027 1.91888 12.8789L1.14142 12.99C0.854443 13.031 0.563798 12.9454 0.344798 12.7555C0.125799 12.5655 0 12.2899 0 12V3.00001C0 2.71012 0.125799 2.43449 0.344798 2.24455ZM2 4.1515V10.8485C5.98206 10.3128 10.0179 10.3128 14 10.8485V4.1515C10.0179 4.68723 5.98206 4.68723 2 4.1515Z"
                fill={props.fill || 'currentColor'}
            />
        </svg>
    );
}
